import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import $ from 'jquery'
import OwlCarousel from 'react-owl-carousel'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'
// Components
import ProductCard from '../components/ProductCard'
import PageTransition from '../components/PageTransition'
import CategoriesNav from '../components/CategoriesNav'
// CSS
import '../assets/css/home.css'
// Images
import Banner from '../assets/images/banner.png'
import Offer from '../assets/images/offer.jpg'
// Icons
import ShippingIcon from '../assets/icons/shipping.png'
import CoinIcon from '../assets/icons/coin.png'
import TwentyFourIcon from '../assets/icons/24-hour.png'
import BlockquoteIcon from '../assets/icons/blockquote.png'

export default function Home(props) {

  const [sideContentShow, setSideContentShow] = useState(false);

  return (
    <div className='home_page'>
      <PageTransition />
      
      <div className='container'>
        <CategoriesNav categories={props.categories} />

        <div className='main_content'>
          <header>
            <div className='slider'>
              <OwlCarousel
                className='owl-theme'
                items={1}
                autoPlay={true}
                autoplayHoverPause={true}
                autoplaySpeed={1000}
                dots={true}
                loop={true}
              >
                <div className='item'>
                  <img src={require('../assets/images/slider banners/1.png')} alt='slider' />
                </div>
                <div className='item'>
                  <img src={require('../assets/images/slider banners/2.png')} alt='slider' />
                </div>
                <div className='item'>
                  <img src={require('../assets/images/slider banners/3.png')} alt='slider' />
                </div>
              </OwlCarousel>
            </div>
            
            <div className='banner select_n' style={{marginTop: '30px'}}>
              <Link to='/' className='card'>
                <img src={require('../assets/images/highlight banners/1.png')} alt='banner' />
              </Link>
              <Link to='/' className='card'>
                <img src={require('../assets/images/highlight banners/2.png')} alt='banner' />
              </Link>
              <Link to='/' className='card'>
                <img src={require('../assets/images/highlight banners/3.png')} alt='banner' />
              </Link>
            </div>
          </header>
        </div>
      </div>

      <div className='container' style={{overflow: 'hidden', display: 'block'}}>
        <div className='services' style={{marginTop: '20px'}}>
          <div className='card'>
            <img src={ShippingIcon} className='select_n' alt='service' />
            <div className='info'>
              <span>FREE SHIPPING & RETURN</span>
              <p>Free shipping on all orders over $99</p>
            </div>
          </div>
          
          <div className='card'>
            <img src={CoinIcon} className='select_n' alt='service' />
            <div className='info'>
              <span>MONEY BACK GUARANTEE</span>
              <p>100% money back guarantee</p>
            </div>
          </div>
          
          <div className='card'>
            <img src={TwentyFourIcon} className='select_n' alt='service' />
            <div className='info'>
              <span>ONLINE SUPPORT 24/7</span>
              <p>Lorem ipsum dolor sit amet.</p>
            </div>
          </div>
        </div>
    
        <section className='featured_products'>
          <div className='section_header'>
            <h2 className='select_n'>Featured Products</h2>
          </div>
          <div className='section_content'>
            <div className='products_container'>
              <OwlCarousel
                className='owl-theme'
                items={6}
                autoPlay={true}
                autoplayHoverPause={true}
                
                autoplaySpeed={1000}
                responsive={{
                  1150: {items: 6},
                  800: {items: 4},
                  600: {items: 3},
                  0: {items: 2}
                }}
                dots={true}
                margin={10}
              >
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Ve Neck Half Sleve Men T-Shirt'
                  category={[{link: 'mens', name: 'Mens'}, {link: 'mens-cloths', name: 'Clothes'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
              </OwlCarousel>
            </div>
          </div>
        </section>
    
        <section className='products_group'>
          <div className='group_container'>
            <h3 className='title select_n'>Top Rated Products</h3>
            <div className='products_container'>
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
            </div>
          </div>
          
          <div className='group_container'>
            <h3 className='title select_n'>Best Selling Products</h3>
            <div className='products_container'>
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
            </div>
          </div>
          
          <div className='group_container'>
            <h3 className='title select_n'>Latest Products</h3>
            <div className='products_container'>
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
              <ProductCard 
                card={2}
                productId='1'
                thumbnail={require('../assets/images/product.png')}
                title='Web design and development crash course by - CodoHov'
                ratings={4}
                realPrice='100'
                discountPrice='80'
              />
            </div>
          </div>
        </section>

        <section className='featured_products'>
          <div className='section_header'>
            <h2>Electronic Accessories</h2>
          </div>

          <div className='section_content'>
            <div className='featured_products_containers'>
              <OwlCarousel
                className='owl-theme'
                items={6}
                autoPlay={true}
                autoplayHoverPause={true}
                
                autoplaySpeed={1000}
                responsive={{
                  1150: {items: 6},
                  800: {items: 4},
                  600: {items: 3},
                  0: {items: 2}
                }}
                dots={true}
                margin={10}
              >
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
              </OwlCarousel>
            </div>
          </div>
        </section>
        
        <section className='featured_products'>
          <div className='section_header'>
            <h2>Kids Collection</h2>
          </div>
          
          <div className='section_content'>
            <div className='featured_products_containers'>
              <OwlCarousel
                className='owl-theme'
                items={6}
                autoPlay={true}
                autoplayHoverPause={true}
                
                autoplaySpeed={1000}
                responsive={{
                  1150: {items: 6},
                  800: {items: 4},
                  600: {items: 3},
                  0: {items: 2}
                }}
                dots={true}
                margin={10}
              >
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
                <ProductCard 
                  card={1}
                  productId='1'
                  thumbnail={require('../assets/images/product.png')}
                  title='Product Title'
                  category={[{link: 'mens', name: 'MENS'}, {link: 'mens-cloths', name: 'CLOTHES'}]}
                  ratings={4}
                  hotDeal={true}
                  realPrice='100'
                  discountPrice='80'
                  discount='20%'
                  setShowQuickView={props.setShowQuickView}
                />
              </OwlCarousel>
            </div>
          </div>
        </section>
        
        <form className='newsletter_subscribe_form'>
          <div className='form_container'>
            <div className='title'>Subscribe Newsletter</div>
            <p>Get all the latest information on Events, Sales and Offers.</p>
            <label htmlFor='newsletter_input' className='input_group'>
              <span className='fas fa-envelope'></span>
              <input type='text' id='newsletter_input' placeholder='Email Address' />
            </label>
            <button>Subscribe</button>
          </div>
        </form>
      </div>
    </div>
  )
}
